<template>
  <div>

       <div class="button" @click="tiaozhuan">跳转</div>

  </div>
</template>

<script>
export default {
 data(){
     return{
         userInfor:{
      cardNum: "MLb3kCzgj6Z6hNKmWsVo65hH1TzPNfnpNirgz6d0QM4=",
      name: decodeURIComponent("%E5%91%A8%E8%B5%A2"), // 需要做decodeURIComponent处理
      phone: "HmIkSe3r4h3evqYWZlpy2w==",
      userId:"1458983807414763500"
}
     }
 },
 methods:{
     tiaozhuan(){
         this.$router.push({path:'/Index',query:{userInfor1:JSON.stringify(this.userInfor)}})
     }
 }
}
</script>

<style>
.button{
    width: 100px;
    height: 100px;
    background-color: aquamarine;
}
</style>